@if (type() === 'create-new') {
  <create-noon-report (save)="onSaveCreate()" (close)="onClose()"></create-noon-report>
} @else if (type() === 'details') {
  <noon-report-details (close)="onClose()">˝</noon-report-details>
}
